<template>
    <div>
        <v-btn @click="emitPayload()">
            Add Test {{ methodVariant | capitalize }}
        </v-btn>
    </div>
</template>

<script>

export default {
    props: {
        methodVariant: {
            type: String,
            default: 'delivery'
        },
    },
    filters: {
        capitalize(value) {
            if (!value) return '';
            value = value.toString().toLowerCase();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },
    methods: {
        emitPayload() {
            let payload = {
                provider: 'KAOSHI_TEST_PROVIDER',
            };
            this.$emit('onFinished', payload);
        },
    },
};
</script>

<style scoped>
.v-input.v-input--switch >>> .v-input__control label {
    color: #000 !important;
}
</style>
